import React from 'react';
import {IOffer} from "../../../../../../../../app/interfaces/offer/IOffer";
import ForwarderField from "../../../../../../../../components/shared/form/detailsFields/ForwarderField/ForwarderField";

type OfferCustomerManagerProps = {
    offer: IOffer;
};

const OfferCustomerManager: React.FC<OfferCustomerManagerProps> = ({
                                                                       offer
                                                                   }) => {
    if (offer.customerManager === null) {
        return null;
    }

    return (
        <div className={'details-box-item-field-value'}>
            <ForwarderField user={offer.customerManager}
                            chatReplyTo={{
                                type: 'RELEASE',
                                description: offer.chatDescription,
                                id: offer.orderReleaseXid,
                                idExt: null
                            }}/>
        </div>
    );
};

export default OfferCustomerManager;
